import { getFilenameDetails } from "../utils/documents";
import Document from "./document";

const Attachments = ({ attachments, labels }) => {
  attachments = attachments.map((att) => ({ ...att, ...getFilenameDetails(att.fileName) }));
  return (
    <section className="survey-detail__attachments">
      <h3 className="survey-detail__attachments-title">
        {labels?.WELFARE_ATTACHMENTS || "Attachments"}
      </h3>
      <div className="survey-detail__attachments-list">
        {attachments?.map((attachment) => (
          <Document doc={attachment} key={attachment.id} />
        ))}
      </div>
    </section>
  );
};

export default Attachments;
